import { Stack } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Aggregate as View } from 'ui-components/components/molecules/Visualization/Aggregate'
import { setAggregateProperty } from '~map-preview/states/hexagons'
import { useNumericProperties } from '~map-preview/states/map'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'
import { Aggregate as TypeAggregate } from '~map-preview/types/__generated/gql/graphql'

export const AggregateHexagon = () => {
  const dispatch = useDispatch()
  const { visualization, setVisualization } = useMapToolbarStore()
  const numericProperties = useNumericProperties()

  const properties = [
    { label: 'Location count', name: 'count' } as any,
    ...numericProperties
  ]

  useEffect(() => {
    if (visualization) {
      const selected: TypeAggregate | undefined =
        visualization &&
        (Object.values(visualization)[0] as TypeAggregate | undefined)
      if (selected?.id === 'hexagon') {
        dispatch(
          setAggregateProperty(
            selected?.aggregate ? selected.aggregate : properties[0].name
          )
        )
      }
    }
  }, [visualization, properties])

  const handleChange = (event) => {
    const tmp = { ...visualization }
    if (tmp['hexagon']) {
      tmp['hexagon']['aggregate'] = event.target.value
    }
    setVisualization(tmp)
  }

  const selected: TypeAggregate | undefined =
    visualization &&
    (Object.values(visualization)[0] as TypeAggregate | undefined)

  return (
    <Stack
      flexDirection={'row'}
      gap={1}
    >
      <View
        value={selected?.aggregate ? selected.aggregate : properties[0].name}
        options={properties}
        onChange={handleChange}
      />
    </Stack>
  )
}
